<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <select
      class="form-control"
      :id="vesselKey"
      autocomplete="off"
      v-model="inputValue"
      @input="emit"
      @change="emit"
      @blur="emit"
      @keyup.delete="emit"
      :disabled="disabled"
    >
      <option
        v-for="vesselBerthBook in items"
        v-bind:key="vesselBerthBook.id"
        :value="vesselBerthBook.name"
      >{{ vesselBerthBook.name }}
      </option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'

export default {
  name: 'VesselInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {

    inputName: {
      default: 'berth'
    },

    items: {
      type: [Array, Object],
      default: () => []
    },

    vesselId: {
      type: [Number],
      default: null
    }
  },

  computed: {
    vesselKey () {
      return `form-pass-berth-${this.vesselId}`
    }
  }
}
</script>
